import { action } from 'satcheljs';
import { ClientItemId } from 'owa-client-ids';
import { ViewType } from 'owa-calendar-actions';
import EventScope from 'owa-service/lib/contract/EventScope';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';

/**
 * Forwards the event
 */
export const forwardEvent = action(
    'forwardEvent',
    (
        calendarEventId: ClientItemId,
        notes: string,
        actionSource: ViewType,
        eventScope: EventScope,
        forwardees: AttendeeType[]
    ) => ({
        calendarEventId,
        notes,
        eventScope,
        actionSource,
        forwardees,
    })
);
